import { pipe, prop, reverse, sortBy } from 'ramda';

export const sortByProp = pipe(prop, sortBy);
export const sortByName = sortByProp('name');
export const sortByPosition = sortByProp('position');
export const sortByCreatedAt = sortByProp('createdAt');
export const sortByReversedCreatedAt = pipe(sortByCreatedAt, reverse);
